module.exports = __webpack_public_path__ + "img/07.2edf9ac9.jpg";